import { useTranslation } from 'react-i18next';
import { StatusPill } from '@ui-kit';

export interface ForbiddenCountBadgeProps {
  count: number;
}

/** 검사 결과 요약 배지 — 0건은 success 톤, 1건 이상은 danger 톤 */
export function ForbiddenCountBadge({ count }: ForbiddenCountBadgeProps) {
  const { t } = useTranslation();
  return (
    <StatusPill tone={count === 0 ? 'success' : 'danger'}>
      {t('terminologyManagement.checker.violationCount', { count })}
    </StatusPill>
  );
}
